module.exports = __webpack_public_path__ + "img/pet_record.c0cc8d10.svg";